const Loader = () => {
  return (
    <div className="loader">
      <div className="circle"></div>
    </div>
  );
};

export default Loader;
